import { render, staticRenderFns } from "./LinksHomepageContainer.vue?vue&type=template&id=8074f50e&scoped=true&"
import script from "./LinksHomepageContainer.vue?vue&type=script&lang=js&"
export * from "./LinksHomepageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8074f50e",
  null
  
)

export default component.exports